(ns ui.editors.card.associations.event
  (:require
   [re-frame.core :as rf]
   [ui.editors.card.model :as common-model]
   [common.util :as cu]
   [ui.editors.card.associations.model :as model]))

(def card-config-full-path common-model/card-config-full-path)

(rf/reg-cofx
 ::inject-editor-data
 (fn [cofx]
   (let [db (:db cofx)
         card (get-in db common-model/card-full-path)
         card-config (:card/config card)]
     (assoc cofx
            :card card
            :card-config card-config))))

(def standard-intercept
  [rf/trim-v (rf/inject-cofx ::inject-editor-data)])

(rf/reg-event-fx
 ::add-entity-type
 standard-intercept
 (fn [{:keys [db card card-config]} [entity-type]]
   (let [card-entity-type (:card/entity-type card)
         new-table-config (model/create-default-table-config
                           {:card-entity-type card-entity-type
                            :associated-entity-type entity-type})
         new-config (update card-config :tables (fnil conj []) new-table-config)]
     {:db (assoc-in db card-config-full-path new-config)})))

(rf/reg-event-fx
 ::remove-entity-type
 standard-intercept
 (fn [{:keys [db card-config]} [removed-entity-type]]
   (let [new-card-config (update card-config
                                 :tables
                                 (fn [prev-tables]
                                   (->> prev-tables
                                        (cu/remove-by :entity-type removed-entity-type)
                                        (vec))))]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::add-table-column
 standard-intercept
 (fn [{:keys [db card-config]} [table-index field]]
   (let [new-card-config (update-in card-config
                                    [:tables table-index :columns]
                                    (fnil conj [])
                                    {:field field})]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::remove-table-column
 standard-intercept
 (fn [{:keys [db card-config]} [table-index field]]
   (let [new-card-config (update-in card-config
                                    [:tables table-index :columns]
                                    (fn [cols]
                                      (->> cols
                                           (cu/remove-by :field field)
                                           (vec))))]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::reorder-table-columns
 standard-intercept
 (fn [{:keys [db card-config]} [table-index source-index destination-index]]
   (let [new-card-config (update-in card-config
                                    [:tables table-index :columns]
                                    (fn [prev-columns]
                                      (cu/vec-move prev-columns source-index destination-index)))]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::set-table-sort-by-field
 standard-intercept
 (fn [{:keys [db card-config]} [table-index sort-by-field]]
   (let [new-card-config (assoc-in card-config
                                   [:tables table-index :sort-model 0 :field]
                                   sort-by-field)]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::set-table-sort-direction
 standard-intercept
 (fn [{:keys [db card-config]} [table-index sort-direction]]
   (let [new-card-config (assoc-in card-config
                                   [:tables table-index :sort-model 0 :sort-direction]
                                   sort-direction)]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::reorder-tables
 standard-intercept
 (fn [{:keys [db card-config]} [source-index destination-index]]
   (let [new-card-config (update card-config
                                 :tables
                                 (fn [prev-tables]
                                   (cu/vec-move prev-tables source-index destination-index)))]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::set-group-by-association-type
 standard-intercept
 (fn [{:keys [db card-config]} [table-index group-by-association-type?]]
   (let [new-card-config (assoc-in card-config
                                   [:tables table-index :group-by-association-type?]
                                   group-by-association-type?)]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::set-entity-peek-visible-fields-strategy
 standard-intercept
 (fn [{:keys [db card-config]} [table-index visible-fields-strategy]]
   (let [new-card-config (assoc-in card-config
                                   [:tables table-index :entity-peek :visible-fields-strategy]
                                   visible-fields-strategy)]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::add-entity-peek-field
 standard-intercept
 (fn [{:keys [db card-config]} [table-index field-to-add]]
   (let [new-card-config (update-in card-config
                                    [:tables table-index :entity-peek :visible-fields]
                                    (fnil conj []) field-to-add)]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::remove-entity-peek-field
 standard-intercept
 (fn [{:keys [db card-config]} [table-index field-to-remove]]
   (let [new-card-config (update-in card-config
                                    [:tables table-index :entity-peek :visible-fields]
                                    (fn [fields]
                                      (->> fields
                                           (filterv (fn [field]
                                                      (not= field field-to-remove))))))]
     {:db (assoc-in db card-config-full-path new-card-config)})))

(rf/reg-event-fx
 ::reorder-entity-peek-fields
 standard-intercept
 (fn [{:keys [db card-config]} [table-index source-index destination-index]]
   (let [new-card-config (update-in card-config
                                    [:tables table-index :entity-peek :visible-fields]
                                    (fn [fields]
                                      (cu/vec-move fields source-index destination-index)))]
     {:db (assoc-in db card-config-full-path new-card-config)})))
